import React from 'react';
import { Field, Checkbox } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import CwdChartSection from '../CwdChartSection';
import { IWorksheetComponent } from '../../../Core';

let MetricCompactionCwdSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector = undefined }) => {
  const enterConvertedWetDensity =
    useSelector(createWorksheetSelector!('Preparation.EnterConvertedWetDensity')) ?? false;

  return (
    <>
      <ListFieldSection>
        <Field
          input={<Checkbox />}
          label="Enter converted wet density data"
          name="Preparation.EnterConvertedWetDensity"
        />
      </ListFieldSection>
      {enterConvertedWetDensity && <CwdChartSection />}
    </>
  );
};

MetricCompactionCwdSection = withInjectedProps(MetricCompactionCwdSection);

export { MetricCompactionCwdSection };
export default MetricCompactionCwdSection;
